import type { TypographyVariantsOptions } from "@mui/material/styles";

export const typography = {
	fontFamily: "'Inter', 'Plus Jakarta Sans', sans-serif",
	// Use pixel values for consistent sizing across environments.
	// Internal-tool dialect of Calm Mobility: scale shifted down one step,
	// weights capped at 500, letter-spacing -2% on body/headings.
	body1: {
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: 1.57,
		letterSpacing: "-0.02em",
	},
	body2: {
		fontSize: "13px",
		fontWeight: 400,
		lineHeight: 1.54,
		letterSpacing: "-0.02em",
	},
	button: {
		fontSize: "13px",
		fontWeight: 500,
		letterSpacing: "-0.02em",
	},
	caption: {
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: 1.66,
		letterSpacing: "-0.02em",
	},
	subtitle1: {
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: 1.57,
		letterSpacing: "-0.02em",
	},
	subtitle2: {
		fontSize: "13px",
		fontWeight: 500,
		lineHeight: 1.54,
		letterSpacing: "-0.02em",
	},
	overline: {
		fontSize: "11px",
		fontWeight: 500,
		letterSpacing: "0.5px",
		lineHeight: 1.45,
		textTransform: "uppercase",
	},
	h1: {
		fontSize: "40px",
		fontWeight: 500,
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
	},
	h2: {
		fontSize: "32px",
		fontWeight: 500,
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
	},
	h3: {
		fontSize: "28px",
		fontWeight: 500,
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
	},
	h4: {
		fontSize: "24px",
		fontWeight: 500,
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
	},
	h5: {
		fontSize: "20px",
		fontWeight: 500,
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
	},
	h6: {
		fontSize: "16px",
		fontWeight: 500,
		lineHeight: 1.25,
		letterSpacing: "-0.02em",
	},
} satisfies TypographyVariantsOptions;
